import { useTranslation } from '@/app/components/translations/Translation';
import { useCuriosityManager } from '@/app/common/CuriosityManagerProvider.tsx';
import { DeferredPaymentsMessageContainer, DescriptionFilter, Link } from './styled';
import type { Localization } from '../../../common/Localization';
import { getDeferredPaymentsImagePath } from './utils';

type Props = {
  localization: Localization;
  link: string;
};

const DeferredPaymentsMessage = ({ localization, link }: Props) => {
  const { t } = useTranslation();
  const { curiosityClickEvents } = useCuriosityManager();

  const handleClick = () => {
    curiosityClickEvents.deferredPaymentsFilterDetails();
  };

  return (
    <DeferredPaymentsMessageContainer>
      <img
        src={getDeferredPaymentsImagePath({ localization, isMessage: true })}
        alt={t('vacation.oss.deferred_payments.filter.description')}
        width={48}
        height={48}
      />
      <DescriptionFilter>{t('vacation.oss.deferred_payments.filter.description')}</DescriptionFilter>
      <Link href={link} target="_blank" rel="nofollow noopener noreferrer" onClick={handleClick}>
        {t('vacation.oss.deferred_payments.filter.cta')}
      </Link>
    </DeferredPaymentsMessageContainer>
  );
};

export default DeferredPaymentsMessage;
